import { render, staticRenderFns } from "./TextAreaMC.vue?vue&type=template&id=cafae14a&"
import script from "./TextAreaMC.vue?vue&type=script&lang=js&"
export * from "./TextAreaMC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports